function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import React, { useCallback, useEffect, useState, useRef } from 'react';
import { Modal } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import T from 'prop-types';
import { hideModal } from '../../redux/actions';
import text from '../../text';
import { Button } from '../button';
import Icon from '../icon/Icon';
import { noop } from 'lodash';
export var WARN_MODAL = 'WARN_MODAL';
var WarnModal = function(param) {
    var show = param.show, onConfirm = param.onConfirm, title = param.title, body = param.body, _param_okLabel = param.okLabel, okLabel = _param_okLabel === void 0 ? text('ok') : _param_okLabel, timer = param.timer, onCancel = param.onCancel;
    var dispatch = useDispatch();
    var _useState = _sliced_to_array(useState(timer), 2), timeLeft = _useState[0], setTimeLeft = _useState[1];
    var timerRef = useRef(null);
    var onHide = useCallback(function() {
        return dispatch(hideModal(WARN_MODAL));
    }, [
        dispatch
    ]);
    var onOk = useCallback(function() {
        onConfirm();
        onHide();
    }, [
        onConfirm,
        onHide
    ]);
    // Reset timeLeft when show or timer changes
    useEffect(function() {
        if (show) {
            setTimeLeft(timer);
        }
    }, [
        show,
        timer
    ]);
    // Handle the countdown timer
    useEffect(function() {
        // Only start timer when modal is shown and there's a timer value
        if (show && timer > 0) {
            // Clear any existing timer
            if (timerRef.current) {
                clearInterval(timerRef.current);
            }
            // Set up new timer
            timerRef.current = setInterval(function() {
                setTimeLeft(function(prevTime) {
                    if (prevTime <= 1) {
                        if (timerRef.current) {
                            clearInterval(timerRef.current);
                            timerRef.current = null;
                        }
                        onOk();
                        return 0;
                    }
                    return prevTime - 1;
                });
            }, 1000);
        }
        // Cleanup function to clear interval when component unmounts or dependencies change
        return function() {
            if (timerRef.current) {
                clearInterval(timerRef.current);
                timerRef.current = null;
            }
        };
    }, [
        show,
        timer,
        onOk
    ]);
    return /*#__PURE__*/ React.createElement(Modal, {
        centered: true,
        show: show,
        onHide: onCancel ? function() {
            onCancel();
            onHide();
        } : onHide,
        backdrop: "static"
    }, /*#__PURE__*/ React.createElement(Modal.Header, {
        className: "centered",
        closeButton: true
    }, /*#__PURE__*/ React.createElement("div", {
        className: "d-flex flex-column align-items-center justify-content-center"
    }, /*#__PURE__*/ React.createElement(Icon, {
        icon: "circled-exclamation",
        className: "mb-3"
    }), /*#__PURE__*/ React.createElement("h3", null, title))), /*#__PURE__*/ React.createElement(Modal.Body, {
        className: "text-center"
    }, body), /*#__PURE__*/ React.createElement(Modal.Footer, null, /*#__PURE__*/ React.createElement("div", {
        className: "d-flex flex-column w-100"
    }, /*#__PURE__*/ React.createElement(Button, {
        autoFocus: true,
        className: "full-width",
        onClick: onOk
    }, okLabel), timer > 0 ? /*#__PURE__*/ React.createElement("div", {
        className: "text-center mt-2"
    }, "Proceeding in ", timeLeft, " seconds.") : null)));
};
WarnModal.propTypes = {
    show: T.bool,
    onConfirm: T.func,
    title: T.node,
    body: T.node,
    okLabel: T.string,
    timer: T.number,
    onCancel: T.func
};
WarnModal.defaultProps = {
    cancelLabel: text('cancel'),
    okLabel: text('ok'),
    timer: 0,
    onCancel: noop
};
export default WarnModal;
